<sc-modal-wizard #modal>

	<sc-modal-header>		
		<div>
			{{ texts.title[language] }}
		</div>
	</sc-modal-header>

	<sc-modal-wizard-page #sourcePage>
		<sc-modal-body>
			<div class="row align-items-center" style="height: 40vh;">
				<div class="col text-center">
					<div class="mb-4">{{ texts.howTransfer[language] }}</div>
					<div>
						<button class="btn btn-secondary me-2" (click)="modal.navigateTo(linkPage)">
							{{ texts.link[language] }}
						</button>
						<button class="btn btn-secondary me-2" (click)="modal.navigateTo(textPage)">
							{{ texts.text[language] }}
						</button>
						<sc-file-button class="me-2" (filesChanged)="upload($event)" #fileinput>
							<div class="btn btn-secondary" [class.loading]="isUploading">
								{{ texts.file[language] }}
							</div>
						</sc-file-button>
					</div>
				</div>
			</div>
		</sc-modal-body>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #linkPage>
		<sc-modal-body>
			<div class="row h-100 align-items-center">
				<div class="col">
					<sc-form form="default">
						<sc-form-row [label]="texts.linkLabel[language]">
							<input [(ngModel)]="postUri" />
						</sc-form-row>
					</sc-form>
				</div>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<div class="row">
				<div class="col">
					<button class="btn btn-secondary btn-circle" (click)="modal.navigateTo(sourcePage)">
						<i class="fa-sharp fa-solid fa-arrow-left"></i>
					</button>
				</div>
				<div class="col-auto">
					<button class="btn btn-dark" [class.loading]="isSending" [disabled]="isSending"
						(click)="createProject();">{{ texts.next[language] }}</button>
				</div>
			</div>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #textPage>
		<sc-modal-body>
			<div class="row h-100 align-items-center">
				<div class="col">
					<sc-form form="default">
						<sc-form-row [label]="texts.linkLabel[language]">
							<textarea rows="8" [(ngModel)]="postText" ></textarea>
						</sc-form-row>
					</sc-form>
				</div>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<div class="row">
				<div class="col">
					<button class="btn btn-secondary btn-circle" (click)="modal.navigateTo(sourcePage)">
						<i class="fa-sharp fa-solid fa-arrow-left"></i>
					</button>
				</div>
				<div class="col-auto">
					<button class="btn btn-dark" [class.loading]="isSending" [disabled]="isSending"
						(click)="createProject();">{{ texts.next[language] }}</button>
				</div>
			</div>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #loadingPage>
		<sc-modal-body>
			<div class="row h-100 align-items-center">
				<div class="col-8 offset-2 text-center">
					<app-loader class="d-block mb-4"></app-loader>
					{{ texts.loading[language] }}
				</div>
			</div>
		</sc-modal-body>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #loadingErrorPage>
		<sc-modal-body>
			<div class="row h-100 align-items-center">
				<div class="col-10 offset-1">
					{{ texts.error[language] }}
					<br>
					<i class="small mt-3 d-inline-block error-message">{{ parseError }}</i>
				</div>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-dark" (click)="modal.navigateTo(sourcePage)">{{ texts.tryAgain[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

</sc-modal-wizard>